import { atom } from "recoil";
import React from "react";
type WalkthroughAtom = Record<string, React.Ref<any>>;
const WALKTHROUGH_ATOM = "WALKTHROUGH_ATOM";
export const walkthroughAtom = atom<WalkthroughAtom>({
  key: WALKTHROUGH_ATOM,
  default: {},
});
